import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const HumanPresenceIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <rect
            x="6"
            y="5"
            width="10"
            height="10"
            rx="5"
            ry="5"
            fill="currentColor"
         />
         <path
            d="M8.97,16h4.06c3.57,0,6.47,2.9,6.47,6.47v.53H2.5v-.53c0-3.57,2.9-6.47,6.47-6.47Z"
            fill="currentColor"
         />
         <path
            d="M22.03,10.68c0-.4-.16-.78-.44-1.06-.28-.28-.66-.44-1.06-.44s-.78.16-1.06.44c-.28.28-.44.66-.44,1.06s.16.78.44,1.06c.28.28.66.44,1.06.44s.78-.16,1.06-.44c.28-.28.44-.66.44-1.06ZM21.66,2.06c0-.62-.5-1.12-1.12-1.12s-1.12.5-1.12,1.12v4.5c0,.62.5,1.12,1.12,1.12s1.12-.5,1.12-1.12V2.06Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default HumanPresenceIcon
